import { configureStore } from '@reduxjs/toolkit';
import projectReducer from './app/features/project/projectSlice';
import userReducer from './app/features/user/userSlice';
import workspaceReducer from './app/features/workspace/workspaceSlice';
import itemsReducer from './store/itemsSlice';
import { actionToPlainObject } from './actionToPlainObject';

const store = configureStore({
  reducer: {
    project: projectReducer,
    user: userReducer,
    workspace: workspaceReducer,
    items: itemsReducer,
  },
  middleware: () => [actionToPlainObject],
});

export default store;
